import React, { Component } from 'react'

import Font from '../../atoms/Font'
import ImageContent from '../../atoms/ImageContent'
import Rating from '../../atoms/Rating'

import T from '../../../translate/T'

import style from './style.css'

class FeaturedEvents extends Component {
    render(){
        
        return(
            <div className={`${style.wrapfeatured}`}>
                <ImageContent image={`${window.URL_ASSETS_BASE}uploads/covers/${this.props.cover}`}>
                    <Rating label={T.txt('difficulty')} exp={this.props.exp} />
                    <Font size="24px" weight="100" color="white" style={{margin: '20px 0'}}>{this.props.name}</Font><br />
                    <Font size="14px" weight="100" color="white" style={{fontStyle: 'italic'}}>{this.props.price}</Font>
                </ImageContent>
            </div>
        )
    }
}

export default FeaturedEvents


// WEBPACK FOOTER //
// ./src/components/molecules/FeaturedEvents/index.js